"use client";

import ProductCarousel from "@/components/ProductCarousel/ProductCarousel";
import Button from "@/components/UI/Button/Button";
import useRegionAndLocale from "@/hooks/useRegionAndLocale";
import { useI18n } from "@/i18n/client";
import styles from "./EmptyCart.module.scss";

export const EmptyCart = () => {
	const t = useI18n();
	const { region, lang } = useRegionAndLocale();

	return (
		<>
			<div className={styles.emptyCart}>
				<h2>{t("Cart.emptyCartPage")}</h2>
				<Button
					className={styles.startShoppingButton}
					as='link'
					href={`/${region}/${lang}`}
					variant='primary'
				>
					{t("Cart.startShopping")}
				</Button>
			</div>

			<ProductCarousel
				algoliaSettings={{
					algoliaGroup: "Trending Items",
				}}
				graphqlId=''
				title={t("Cart.featuredProducts")}
				placementProductId='cart-page'
				useProductCards={true}
			/>
		</>
	);
};
